import React from 'react';
import cc from 'classcat';

import styles from './styles.module.scss';

interface Props {
  numItems?: number;
  pageLimit: number;
  currentPage: number;
  baseURL: string;
}

const Pagination = ({ pageLimit, baseURL, numItems, currentPage }: Props) => {
  const pageURL = (pageNum: number) => {
    if (pageNum === currentPage) {
      return undefined;
    } else if (pageNum === 1) {
      return baseURL;
    }
    return `${baseURL}/page/${pageNum}`;
  };

  const totalPages = numItems ? Math.ceil(numItems / pageLimit) : 0;

  return (
    <div className={styles.pagination}>
      {Array.from(Array(totalPages), (_, i) => i + 1).map((pageNum) => (
        <a key={pageNum} href={pageURL(pageNum)} className={cc({ [styles.active]: pageNum === currentPage })}>
          {pageNum}
        </a>
      ))}
    </div>
  );
};

export default Pagination;
